module.exports = __webpack_public_path__ + "img/peter.69cfe5e0.jpeg";